<main class="main">
  <section class="wrap-title"
    style="background: url('https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/Consulta_1920x324.png'); background-size: cover;">
    <div class="layout">
      <h1 class="title-page">Consulta Veicular</h1>
    </div>
  </section>

  <section class="wrap-content">
    <div class="layout">
      <div class="content">
        <div class="left">
          <div class="ckeditor">
            <p>Sem surpresas lá na frente: das informações mais habituais às mais completas, a Union oferece os sistemas que a sua empresa precisa para buscar tudo o que diz respeito à informação veicular. Dados atualizados e confiáveis, com todas as informações necessárias para que a sua empresa realize a melhor negociação com o próximo comprador.</p>
          </div>
          <div class="button">
            <a class="btn gradient" href="consulta-veicular/">Exemplo da consulta</a>
          </div>
        </div>
      </div>

    </div>
  </section>

  <section class="wrap-highlights">
    <div class="layout">
      <div class="list-topics">
        <div class="topic">
          <div class="icon">
            <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/Grupo-1003@2x.png">
          </div>
          <div class="text">
            <h3>Consulta composta</h3>
            <p>Liberdade para fazer suas escolhas e flexibilidade para atender às necessidades específicas da sua
              empresa. Selecione os itens de maior relevância para o seu negócio, personalizando as consultas e mantendo
              as opções selecionadas sempre na página inicial.</p>
          </div>
        </div>
        <div class="topic">
          <div class="icon">
            <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/Grupo-1004@2x.png">
          </div>
          <div class="text">
            <h3>Cadastro de usuário</h3>
            <p>Praticidade e suporte para garantir a melhor oportunidade de gerenciamento. Realize o cadastro de
              diversos usuários na conta de um único cliente e tenha facilidade nos acessos.</p>
          </div>
        </div>
        <div class="topic">
          <div class="icon">
            <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/Grupo-1005@2x.png">
          </div>
          <div class="text">
            <h3>Histórico de consultas</h3>
            <p>Do histórico de leilão e proprietários, indício de sinistro até a base Estadual/Nacional. Precisou de
              acesso a antigas consultas? Elas estarão armazenadas no sistema e disponíveis para acesso do histórico a
              qualquer momento.</p>
          </div>
        </div>
        <div class="topic">
          <div class="icon">
            <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/Grupo-1007@2x.png">
          </div>
          <div class="text">
            <h3>Resgate consultas</h3>
            <p>Você pode fazer uso de antigas consultas da melhor forma para novas operações. Nosso sistema permite o
              acesso a todos os dados realizados previamente: basta usar o número de ID e a chave consultada
              anteriormente.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <app-consults></app-consults>

  <app-contact-box></app-contact-box>

</main>
